const NFTGAME_CONTRACT_ADDRESS = "0x6E47151628CBb24ccdd07FB66AC334713E91fB3F";
const DYNAMIC_GAME_FACET_ADDRESS = "0x2b21C7232131782af928a0319D713bDC68B6C19D";
const STAKE_FACET_ADDRESS = "0x5a3E338d8AB993476587030e27675d80bdF6Ff52";

const transformCharacterData = (characterData) => {
    return {
        name: characterData.name,
        imageURI: characterData.imageURI,
        hp: characterData.hp.toNumber(),
        maxHp: characterData.maxHp.toNumber(),
        attackDamage: characterData.attackDamage.toNumber(),
        levels: characterData.levels
    }
}

export { NFTGAME_CONTRACT_ADDRESS, transformCharacterData, DYNAMIC_GAME_FACET_ADDRESS, STAKE_FACET_ADDRESS};